import React from 'react'
import OnVisible from 'react-on-visible'
import { Image } from 'newComponents'
import './styles.scss'

// image import
import approvals from '../../../images/icons/approvals-blue.svg'
import triggers from '../../../images/icons/flag-triggers-blue.svg'
import schedules from '../../../images/icons/schedules-blue.svg'
import toggle from '../../../images/icons/toggle-blue.svg'
import toggleOff from '../../../images/icons/toggle-off-blue.svg'
import plus from '../../../images/icons/plus.svg'
import plusDark from '../../../images/icons/plus-dark.svg'
import arrow from '../../../images/icons/right-arrow.svg'

// ordered objects

const iconCollections = {
  'Workflow Templates': [
    { icon: toggleOff, key: 'toggleOff1', text: 'Feature Flags' },
    { icon: schedules, key: 'schedules1', text: 'Schedules' },
    { icon: approvals, key: 'approvals1', text: 'Approvals' },
    { icon: triggers, key: 'triggers1', text: 'Flag Triggers' },
    { icon: toggle, key: 'toggle1', text: 'Action' }
  ]
}

const IconCollection = ({ icons, textContent }) => {
  if (!icons) return null
  const iconCollection = iconCollections[icons]

  return (
    <OnVisible className="icon-collection">
      <div className="icon-collection-section">
        {/* ICONS */}
        {iconCollection.map((iconObj, index) => {
          const useArrow = iconCollection.length - 2 === index
          const seperator = useArrow ? arrow : plus
          const firstLast = index === 0 || index === iconCollection.length - 1 ? 'first-last' : ''
          const { icon, key, text } = iconObj
          return (
            <div className={`icon-collection-container ${firstLast}`} key={key}>
              <div className="icon-collection-icon-group">
                <Image className="icon-collection-icon" image={{ url: icon }} />
                {index < iconCollection.length - 1 && <Image className="icon-collection-plus-icon" image={seperator} />}
              </div>
              <span className="icon-collection-icon-text">{text}</span>
            </div>
          )
        })}
      </div>
    </OnVisible>
  )
}
export default IconCollection
